import { MATERIAL, MODEL_ID, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Inverse of parseMeshyImageTo3dProData. Builds an openedModel-shaped payload
 * from the current modelSettings so the just-submitted run can be reopened
 * without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseMeshyImageTo3dProData
 */
export const buildMeshyImageTo3dProFromState = (state, id) => {
  const { modelSettings } = state
  const {
    material,
    targetPolycount,
    polygonType,
    inputImage,
    inputImageUrl,
    isPrivate,
    isSmartLowPoly,
    selectedUseCase,
  } = modelSettings || {}

  const inputAssets = inputImage != null
    ? [{
        assetType: 'image',
        source: 'user_upload',
        assetId: inputImage,
        fileUrl: inputImageUrl,
      }]
    : undefined

  return {
    id,
    providerKey: PROVIDER.MESHY,
    providerModelId: MODEL_ID.MESHY_IMAGE_TO_3D_PRO,
    enablePbr: material === MATERIAL.PBR,
    geometryOnly: material === MATERIAL.GEOMETRY_ONLY,
    private: isPrivate,
    useCase: selectedUseCase,
    inputAssets,
    providerRunAttributes: {
      ...(targetPolycount != null && { target_polycount: targetPolycount }),
      ...(!isSmartLowPoly && polygonType != null && { topology: polygonType }),
      ...(isSmartLowPoly && { generate_type: 'LowPoly' }),
    },
  }
}
